import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/index.scss';
import { store } from './Redux'
import { Provider } from 'react-redux'
import App from './Screens/App';
import { SnackbarProvider } from 'notistack';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <SnackbarProvider 
            maxSnack={5}
            preventDuplicate
            autoHideDuration={3000}
            anchorOrigin={{horizontal:'center',vertical:'top'}}
        >
            <App />
        </SnackbarProvider>
    </Provider>
);